/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartFunnelV = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 2v2c-1.897 0-3.311 2.075-4.176 5.778-.333 1.427-.558 2.991-.693 4.591a38.456 38.456 0 0 0-.122 2.101l-.009.455V22H7v-5c0-.05 0-.123-.002-.22l-.022-.71a39.267 39.267 0 0 0-.067-1.186c-.114-1.598-.32-3.194-.637-4.674C5.425 6.255 3.975 4 2 4V2zm-6.976 14.003L8.974 16l.014.368.007.27.002.113L9 20h6v-3.085c.003-.267.01-.573.024-.912zM15.728 10H8.272c.265 1.287.452 2.64.573 4h6.31a35.41 35.41 0 0 1 .573-4zm2.396-6H5.88l.077.097c.751.995 1.35 2.315 1.82 3.902L16.224 8c.477-1.609 1.088-2.945 1.855-3.944z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartFunnelV as ChartFunnelV };
